import { ToggleOff, ToggleOn } from "@mui/icons-material";
import { Chip, FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { TEST_CASE_DESCRIPTION_LABEL_LOOKUP } from "redux/slices/lensEditor";

export function SelectTestLabels({ setLabelFilterState }) {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [negated, setNegated] = useState<Set<string>>(new Set());

  const handleSelected = (labels: string[]) => {
    const nextState = new Set(labels);
    setSelected(nextState);
    setLabelFilterState(Array.from(nextState).reduce((acc, label) => ({ ...acc, [label]: negated.has(label) }), {}));
  };

  const handleNegated = (labels: string[]) => {
    const nextState = new Set(labels);
    setNegated(nextState);
    setLabelFilterState(Array.from(selected).reduce((acc, label) => ({ ...acc, [label]: nextState.has(label) }), {}));
  };

  const renderLabelChip = (label: string) => {
    const base = TEST_CASE_DESCRIPTION_LABEL_LOOKUP[label] ?? `Unknown Label - ${label}`;
    const withNegation = `${negated.has(label) ? "Not " : ""} ${base}`;
    return <Chip size="small" color="primary" variant="outlined" key={label} label={withNegation} />;
  };

  // reducing the padding to bring in line with other inputs, the Chips make it larger
  const paddingFix = { "& .MuiOutlinedInput-input": { paddingY: "5px" } };

  return (
    <FormControl>
      <Select<string[]>
        size="small"
        sx={selected.size > 0 ? paddingFix : {}}
        className="min-w-72"
        value={Array.from(selected)}
        multiple
        renderValue={(k) => (
          <div className="min-w-72 flex gap-0.5">{Array.isArray(k) ? k.map(renderLabelChip) : renderLabelChip(k)}</div>
        )}
        onChange={(e) => handleSelected(e.target.value as string[])}>
        {Object.entries(TEST_CASE_DESCRIPTION_LABEL_LOOKUP).map(([key, label], idx) => {
          return (
            <MenuItem key={idx} value={key}>
              <div className="flex w-full items-center justify-between gap-0.5">
                {label}
                {selected.has(key) && negated.has(key) && (
                  <ToggleOff
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNegated(Array.from(negated).filter((l) => l !== key));
                    }}
                  />
                )}

                {selected.has(key) && !negated.has(key) && (
                  <ToggleOn
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNegated([...negated, key]);
                    }}
                    className="text-peri-700"
                  />
                )}
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default SelectTestLabels;
